<template>
  <div class="w-full md:px-6 px-2">
  <div class="tile is-ancestor mx-auto mt-8 md:flex space-x-2 ">
  <div class="tile is-vertical is-8 card-content">
    <div class="tile card">
       <div class="tile is-parent is-vertical">
<!--          <figure class="">
           <img class="h-full w-full rounded overflow-hidden shadow" :url="'https://open-edu-bb.de/'" :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png'" />
          </figure> -->
          <br>
          <div v-if="user.role.name > 0">
            <article  class="tile is-child notification is-primary">
              <h1 class="title">Hallo {{ user.firstName }}, Willkommen auf der eduBB Plattform</h1>
              <p class="subtitle"></p>
            </article>
          </div>
          <div v-else>
            <article  class="tile is-child notification is-primary">
              <h1 class="title">Willkommen auf der eduBB Plattform</h1>
              <p class="subtitle"></p>
            </article>       
          </div> 
        <article class="tile is-child notification is-warning">
          <div v-if="user.role.name == 0" class="content">
          <p class="title">Bitte wählen Sie Ihre Profession aus:</p>
          <div class="mx-auto flex w-full justify-around items-center">
 
              <div class="bt font-montserrat w-full text-black mx-5 z-10">
                
                  <h1 class="font-pacifico hidden sm:block text-6xl mb-10">Produzieren</h1>
                  <!-- <h1 class="text-4xl mb-10 font-raleway">Search for whatsoever recipe you want</h1> -->
                  <router-link to='/profession' class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
                      AUTOREN
                      <!-- <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" />  -->
                  </router-link> 
              </div>
   
              <div class="bt mx-auto flex  w-full justify-center items-center">
                <div class="font-montserrat w-full text-black mx-5 z-10">
                <h1 class="font-pacifico hidden sm:block text-6xl mb-10">Konsumieren</h1>
                    <router-link to='/studentprofession' class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
                      SCHÜLER
                      <!-- <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" />  -->
                  </router-link> 
                  </div>
              </div>
   
              <!-- <div v-if="loading" class="rounded-full absolute bottom-20 bg-blue-300 w-10 h-10">
              </div> -->
          </div>
        </div>
        <div v-else-if="user.role.name == 1">
          <div>
          <div class="bt mx-auto flex w-full justify-center items-center">
                <div class="font-montserrat w-full text-black mx-5 z-10">
                <h1 class="subtitle">Es stehen folgende Bereiche zur Verfügung</h1>
<!--                     <router-link to='/studentprofession' class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
                      SCHÜLER
                    
                  </router-link>  -->
                  </div>
                </div>
              </div>
              <div class="tile is-parent">
             
              </div> 
              <StudentProgress/>
            </div>
        <div v-else-if="user.role.name >= 2">
          <div class="bt font-montserrat w-full text-black mx-5 z-10 py-1 px-4">               
                <h1 class="subtitle">Es stehen folgende Bereiche zur Verfügung</h1>
                <!-- <h1 class="text-4xl mb-10 font-raleway">Search for whatsoever recipe you want</h1> -->
               <div class="buttons">
         
                  <b-button tag="router-link" class="font-medium text-gray-900 mb-3 py-1 px-4" to='/onboarding' type="is-link" rounded>Tutorial</b-button>
                    <!-- <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" />  -->
                  <b-button tag="router-link" class="font-medium text-gray-900 mb-3 py-1 px-4" to='/instructor-courses' type="is-link" rounded>Autoren Kursbereich</b-button>
                  <b-button tag="router-link" class="font-medium text-gray-900 mb-3 py-1 px-4" to='/modules' type="is-link" rounded>Content Module</b-button>
        
                </div>           
            </div>
          </div>
        </article>
        <KeyPerformance />
      </div>
 <!--      <div class="tile is-parent">
        <article class="tile is-child notification is-info">
  
          <figure class="">
            <img class="h-full w-full rounded overflow-hidden shadow" :url="'https://open-edu-bb.de/'" :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png'" />
          </figure>
        </article>
      </div> -->
      <!-- <source :type="mp4"> -->
    </div>

<!--     <div class="tile">
    <div class="tile is-child is-vertical">
      <div class="mx-auto flex w-full justify-around items-center">
      <div class="bt font-montserrat w-full text-black mx-3">
        <button type="submit" class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded-full">
          <router-link to="/register" >Keinen Account? Registrieren!</router-link>
        </button>
        </div>
        <div class="bt mx-auto flex  w-full justify-center items-center">
        <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
          <router-link to="/login" >Bereits einen Account? Login!</router-link>
        </button>
      </div>
    </div>
    </div>
  </div> -->

    <div class="tile is-parent card-content">

    </div>
  </div>
   <div v-if="user.role.name > 0" class="tile is-parent mx-auto mt-8 md:flex space-x-2 card">
    <article class="tile is-child notification is-success card-content">
      <div class="content">
        <p class="title">Neuigkeiten</p>
        <p class="subtitle">Features</p>
        <div class="content">
        
        </div>
      </div>
    </article>
  </div>
</div>

  <!--   <div class="w-full md:px-6 px-2">
      <div class="md:flex md:flex-wrap">
        <div
          class="py-10 md:w-full lg:w-2/3 w-full md:pr-6 sm:border-r border-gray-300"
        >
        <div class="mx-auto w-4/5 text-left font-raleway z-10">
        <img :url="'https://open-edu-bb.de/'" :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png'" />
         <img url="https://open-edu-bb.de/" :src="'' + API_URL + '/uploads/logo_Edu_trans_22da2f69c5.png'" />
        <br>
        <h1 class="font-bold text-black text-6xl mb-10 text-3xl text-gray-900 font-bold mb-10">Willkommen auf der eduBB Plattform </h1>
        <font-awesome-icon class="text-xl" :icon="['fas', 'user-circle']" /> {{ user.firstName }} {{ user.lastName }} 
        <p></p>
        <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-at']" /> {{ user.email }}
        </div>

            <div>
                <section>
                   
                   <br>
                    <div class="mx-auto w-4/5 text-left font-raleway z-10">
                      <h2 class="font-pacifico text-black text-6xl mb-10 text-3xl text-gray-900 mb-10"> Bitte wählen Sie Ihre Profession aus:</h2>
                    </div>
                    <br>
                            <div class="mx-auto flex w-full justify-around items-center">
                              <ul>
                                <li>
                                <div class="bt font-montserrat w-full text-black mx-5 z-10">
                                  
                                    <h1 class="font-pacifico hidden sm:block text-6xl mb-10">Produzieren</h1>
                                   <h1 class="text-4xl mb-10 font-raleway">Search for whatsoever recipe you want</h1> 
                                   <router-link to='/profession' class="bg-green-400 p-5 text-white py-5 px-10 text-xl z-10">
                                        AUTOREN
                                        <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                    </router-link> 
                                </div>
                                </li>
                                <br>
                                <br>
                                <br>
                                <li>
                                <div class="bt mx-auto flex  w-full justify-center items-center">
                                  <div class="font-montserrat w-full text-black mx-5 z-10">
                                  <h1 class="font-pacifico hidden sm:block text-6xl mb-10">Konsumieren</h1>
                                     <router-link to='/studentprofession' class="bg-green-400 p-5 text-white py-5 px-10 text-xl z-10">
                                        SCHÜLER
                                        <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                    </router-link> 
                                    </div>
                                </div>
                                </li>
                              </ul>
                                <div v-if="loading" class="rounded-full absolute bottom-20 bg-blue-300 w-10 h-10">
                                </div> 

                            </div>
                        
                   
                    
                </section>
            
            </div>

        <div class="mx-auto w-4/5 text-left font-raleway z-10">
            <section class="text-left font-montserrat mx-5 z-10">
                <br>
                <br>
                <h2 class="text-6xl font-black my-10 z-10 font-bold text-black text-6xl mb-10 text-3xl text-gray-900 font-bold mb-10">Kurs auf eduBB erstellen!</h2>
                  <div class="video">
                    <video controls class="video-width">
                    <source 
                      :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_02_fe3daffbac.mp4'" 
                      :type="mp4"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                  </div>
                   <div class="flex items-center">
                    HOW TO:&nbsp;
                  <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_02_69ee462efb.pdf'" target="_blank">&nbsp;
                      Tutorial Anleitung
                    </a>
                  </div>
            </section>
        </div>
           // Diesen Button für Menuführung nutzen
            <button
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"
            >
              <router-link to="/courses"> Kurse anzeigen </router-link>
            </button>     

           // Selection Felder für alternative Menuführung  
            <select
              aria-label="Selected tab"
              class="form-select block w-full p-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent relative z-10"
            >
              <option selected class="text-sm text-gray-600">
                Metrics
              </option>
              <option class="text-sm text-gray-600">Notifications</option>
              <option class="text-sm text-gray-600">Announcements</option>
            </select>

        </div>
      </div>
    </div> -->
</div>
</template>

<script>

// import CourseOnboarding from '../components/CourseOnboarding.vue';
/* import HeroSection from '../components/HeroSection.vue'
import FeaturedSection from '../components/FeaturedSection.vue' */
import KeyPerformance from '../components/KeyPerformance.vue'
import StudentProgress from '../components/StudentProgress.vue'

export default {
  name: "Home",
  components: {
    KeyPerformance,
    StudentProgress
  },
  data: function() {
    return {
      user: JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user"))
      : { role: { name: 0 } },
      tab: "Metrics",
      API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "localhost:1338",
    };
  },

  methods: {
/*     activeTab(element) {
      if (element === "Metrics") {
        this.tab = "Metrics";
      } else if (element === "Notifications") {
        this.tab = "Notifications";
      } else if (element === "Annoucements") {
        this.tab = "Annoucements";
      }
    }, */
  },

/*  apollo: {
    modules: {
      query: gql`
        query {
          modules {
            id
            name
            description
            media {
              id
              name
              mime
              url
            }
          }
        }
      `,
    },
 } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
  text-align: left;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
.image {
    height: 200px;
}
.video {
    margin-top: 5rem;
    margin-bottom: 5rem;
}
.video-width {
    width: 100%;
}

@media (max-width: 700px) {
    .long {
        max-width: 100%;
        flex-basis: 100%;
    }
    .image {
        width: 100%;
        height: 100%;
    }
}
</style>
